<classic-report [report]="this.reportVariant" [reportName]="'Trainee Signed In History Report'"
  [defaultDisplayColumns]="this.defaultDisplayColumns" [dateFilterTypes]="this.dateFilters"
  [groupByColumns]="this.groupByColumns">
</classic-report>